module.exports = __webpack_public_path__ + "img/wh-li-icon5.7157dcd7.png";